export default __webpack_public_path__ + "static/media/pencil-soft-autumn.ecf88f49.png";